import { api } from "./client";

export type Topic = {
  topic_id: number;
  name: string;
};

export async function getTopics() {
  return api<Topic[]>("/topics", "GET");
}

export async function createTopic(name: string) {
  return api("/topics", "POST", { name });
}
